import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { Routes, Router, RouterModule , ActivatedRoute, Params} from '@angular/router';
import { LeadService } from '../lead.service';
import {FinanceService} from '../../finance/finance.service';
import { QuotationService } from '../../quotation/quotation.service';
import { Observable } from 'rxjs';
import { Lead } from '../lead';
import { FormControl, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { Angular2TokenService } from 'angular2-token';
import {Location} from '@angular/common';
declare var $:any;

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css'],
  providers: [ LeadService , QuotationService, LoaderService]
})
export class PaymentsComponent implements OnInit {
	lead_id;
	lead_status;
	project_id;
	lead_details:any;
	approveList: any;
	paymentForm: FormGroup;
  basefile = {};
  image: any;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  role:any;

  constructor(
    public activatedRoute: ActivatedRoute,
    public leadService : LeadService,
    private financeService:FinanceService,
    public loaderService : LoaderService,
    private _tokenService: Angular2TokenService,
    private formBuilder: FormBuilder,
    private router: Router,
    private el: ElementRef,
    private route:ActivatedRoute,
    private quotationService : QuotationService,
    private _location: Location

  	) { }

  ngOnInit() {

  	this.activatedRoute.params.subscribe((params: Params) => {
        this.lead_id = params['leadId'];
        this.project_id = params['projectId'];

      });
  	 this.paymentForm = this.formBuilder.group({
      'payment_type': ['initial_design', Validators.required],
      'amount': ['', Validators.required],
      'mode_of_payment': ['', Validators.required],
      'bank': [''],
      'branch': [''],
      'date_of_checque': [''],
      'date': [''],
      'transaction_number':[''],
      'image': [''],
      'project_id':[this.project_id,Validators.required],
      'quotation_ids' : new FormArray([]),
      'payment_stage' : ['pre_10_precent', Validators.required]
    });
    this.role = localStorage.getItem('user');
    this.route.queryParams.subscribe(params => {
      this.lead_status = params['lead_status'];
    });

    this.fetchBasicDetails();
    this.getPaymentHistory();
  }


  fetchBasicDetails(){
    this.leadService.getLeadLogs(this.lead_id).subscribe(
      res => {
        this.lead_details = res['lead'];
        this.project_id = res['lead'].project_details.id;
        this.getApprovedBoqList();


      },
      err => {
        console.log(err);
      }
    );
  }

  getApprovedBoqList(){
    this.loaderService.display(true);
  	this.leadService.getApprovedBoqList(this.project_id,this.selectedSet).subscribe(
  		res=>{
        this.loaderService.display(false);
         this.approveList = res['quotations'];

  		},
  		err=>{
          console.log(err);
          this.loaderService.display(false);
  		}
  		);

  }

  selectedSet:any = "pre_10_percent";
  getSet(selectedSet){
    this.selectedSet = selectedSet;
    this.getApprovedBoqList();
    this.paymentForm.patchValue({payment_stage: this.selectedSet});
    if(this.selectedSet == "pre_10_percent"){
      this.paymentForm.patchValue({payment_type: "initial_design"});
    }
    else if(this.selectedSet == "10_50_percent"){
      this.paymentForm.patchValue({payment_type: "final_design"});
    }  
    
  }


   isProjectInWip():boolean {
    var wip_array = ["wip", "pre_10_percent", "10_50_percent", "50_percent", "installation", "on_hold", "inactive"]
    if(this.lead_details && this.lead_details.project_details && this.lead_details.project_details.status && wip_array.includes(this.lead_details.project_details.status)){
      return true
    }
    else{
      return false
    }
  }

 changePaymentMode(event){
    if(event.target.value == "NEFT/RTGS"){
      $(".cheque-mode").css("display", "none");
      $(".neft-mode").css("display", "block");
    }
    else if(event.target.value == "cheque"){
      $(".cheque-mode").css("display", "block");
      $(".neft-mode").css("display", "none");
    }
  }
  array_length;
  msg;
  savePayment(){
    this.loaderService.display(true);
    $('#addPayment').modal('hide');
    this.quotationService.savePayment(this.project_id,this.paymentForm.value, this.basefile).subscribe(
      res => {
        this.getApprovedBoqList();

        this.successalert = true;
        this.successMessage = 'Payment Added successfully!';
        this.loaderService.display(false);
         setTimeout(function() {
            this.successalert = false;
        }.bind(this), 10000);
          this.paymentForm.reset();
        },
      err => {

        console.log(err);
        this.msg = JSON.parse(err._body)["message"]
        console.log(this.msg);
        alert(this.msg);
        this.loaderService.display(false);
      });
  }
  onCheckChange(event){
  	if(event.target.checked){
  		(<FormArray>this.paymentForm.controls['quotation_ids']).push(new FormControl(event.target.value));
  	} else{
      var j:number = 0;
      (<FormArray>this.paymentForm.controls['quotation_ids']).controls.forEach((ctr: FormControl) => {
        if(ctr.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          (<FormArray>this.paymentForm.controls['quotation_ids']).removeAt(j);
          return;
        }

        j++;
      });


    }
     this.array_length = this.paymentForm.controls['quotation_ids'].value.length;
    if(this.array_length > 0){
      $('#bt-disable').prop('disabled', false);
      $('#bt-disable').css('cursor', 'pointer');

    }
    else{
      $('#bt-disable').prop('disabled', true);
      $('#bt-disable').css('cursor', 'not-allowed');
    }

  }
  onChange(event) {
    this.image = event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      // this.basefile = base64.result;
      this.basefile = base64.result

    };

    fileReader.readAsDataURL(this.image);
  }
  payment_details;
  getPaymentQuotation(paymentId){
    this.loaderService.display(true);
    this.financeService.getPaymentQuotation(this.project_id,paymentId).subscribe(
      res=>{
        this.payment_details=res['payment']['quotation_payments'];
        this.loaderService.display(false);
      },
      err=>{
        console.log(err);
        this.loaderService.display(false);
      }
    );

  }
  showAccordion(index,paymentId){
    var this1=this;
    var str='#accordion_'+index;
    // var str2='#package'+index+' i.fa';
    var str3=".combmoduleAccordionRow"+index;
    $(str).on('shown.bs.collapse', function () {
      $(str3).removeClass('d-none');
      //this1.getPaymentDetails(boqid);
    });
    $(str).on('hidden.bs.collapse', function () {
      $(str3).addClass('d-none');
      this1.payment_details=undefined;
    });
    // var str='combmoduleAccordionRow'+index;
    // document.getElementById(str).classList.remove('d-none')
  }
  payment_details_Arr;
  getPaymentHistory(){
    this.loaderService.display(true);
    this.financeService.getPaymentDetails(this.project_id).subscribe(
      res=>{
        this.payment_details_Arr=res.payments;
        this.loaderService.display(false);
      },
      err=>{
        console.log(err);
        this.loaderService.display(false);
      }
    );
  }
   ngAfterViewInit(){

    $(".cheque-mode").css("display", "none");
    $(".neft-mode").css("display", "none");
    $('#bt-disable').prop('disabled', true);
    $('#bt-disable').css('cursor', 'not-allowed');

  }

  approveBoq(boq_id){
    this.loaderService.display(true);
    this.financeService.approveBoq(this.project_id,boq_id).subscribe(
      res=>{
       
        this.loaderService.display(false);
        this.successalert = true;
        this.successMessage = 'BOQ approved successfully!';
         setTimeout(function() {
            this.successalert = false;
        }.bind(this), 10000);
         this.getApprovedBoqList();  
      },
      err=>{
        console.log(err);
        this.loaderService.display(false);
        this.erroralert = true;
        this.errorMessage = JSON.parse(err._body)["message"]
         setTimeout(function() {
            this.successalert = false;
        }.bind(this), 10000);
      }
    );
  }
  quotationidsArr;
  openAddPaymentModal(){
    this.quotationidsArr =this.paymentForm.controls['quotation_ids'].value; 
  }
  paymentReset(){
    this.paymentForm.reset();
    $(".cheque-mode").css("display", "none");
    $(".neft-mode").css("display", "none");
    this.paymentForm.patchValue( {'payment_type':'initial_design'} );
    this.paymentForm.patchValue( {'payment_stage':'pre_10_precent'} );
    this.paymentForm.patchValue( {'project_id':this.project_id} );
    this.paymentForm.controls['quotation_ids'].setValue(this.quotationidsArr);
    
    

  }
}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/payments/payments.component.ts